import { getNonUmbracoUrl } from "./getNonUmbracoUrl"
import { getUmbracoMediaUrl } from "./getUmbracoMediaUrl"

/**
 * Replaces all <a href="..."> links and <img src="..."> tags in an HTML string.
 * - For links: processes href with getNonUmbracoUrl and getUmbracoMediaUrl
 * - For images: processes src with getUmbracoMediaUrl
 * @param html The HTML string to process
 * @returns The HTML string with updated <a> hrefs and <img> src attributes
 */
export function replaceRichTextLinks(
  html?: string,
  replaceStrong?: "h2" | "h4",
): string {
  if (!html) return ""

  // Process <a> tags
  let processedHtml = html.replace(
    /<a\s+([^>]*href=["'])([^"'>]+)(["'][^>]*)>/gi,
    (match, beforeHref, href, afterHref) => {
      let newHref = getNonUmbracoUrl(href, true)
      newHref = getUmbracoMediaUrl(newHref)
      return `<a ${beforeHref}${newHref}${afterHref}>`
    },
  )

  // Process <img> tags
  processedHtml = processedHtml.replace(
    /<img\s+([^>]*src=["'])([^"'>]+)(["'][^>]*)>/gi,
    (match, beforeSrc, src, afterSrc) => {
      const newSrc = getUmbracoMediaUrl(src)
      return `<img ${beforeSrc}${newSrc}${afterSrc}>`
    },
  )

  // Remove aria-level attribute from <li> tags
  processedHtml = processedHtml.replace(
    /<li\s+([^>]*)\s*aria-level=["'][^"']*["']\s*([^>]*)>/gi,
    (match, beforeAriaLevel, afterAriaLevel) => {
      const cleanedAttributes = `${beforeAriaLevel} ${afterAriaLevel}`.trim()
      return `<li${cleanedAttributes ? ` ${cleanedAttributes}` : ""}>`
    },
  )

  // Replace <strong> tags with the specified heading tag if replaceStrong is provided
  if (replaceStrong) {
    processedHtml = processedHtml.replace(
      /<strong([^>]*)>(.*?)<\/strong>/gi,
      (match, attributes, content) => {
        return `<${replaceStrong}${attributes}>${content}</${replaceStrong}>`
      },
    )
  }

  return processedHtml
}
